<template>
    <div v-if="notices.length > 0" class="notices">
        <div style="width: 100%; font-size:1em; position: relative;">
            <button type="button" class="btn-close" @click="dismissNotice"></button>
            <Notice :notices="notices"></Notice>
        </div>
    </div>
</template>

<script>
import api from "@/services/api";
import Notice from "../components/Notice.vue";

export default {
    props: {
    },
    components: {
            Notice,
        },
    data() {
        return {
            notices:[],
            dismissed: false,
        }
    },
    mounted() {
        this.fetchNotices();
    },
    methods: {
        
        fetchNotices: function() {
            api
            .get('/api/v1/notice/getAllActive')
            .then((response) => {
                const dismissedIds = JSON.parse(sessionStorage.getItem('dismissedNotices') || '[]');
                this.notices = response.data.filter(notice => !dismissedIds.includes(notice.id));
            })
            .catch(() => {
                console.log('Retrieving notices failed');
            });
        },
        dismissNotice: function() {
            const dismissedIds = this.notices.map(notice => notice.id);
            sessionStorage.setItem('dismissedNotices', JSON.stringify(dismissedIds));
            this.notices = [];
        },
        }
}
</script>
<style scoped lang="scss">
  .notices p {
    margin:0;
  }
  .btn-close {
    position: absolute; 
    top: 10px; 
    right: 10px; 
    z-index:1;
  }
</style>